import React from 'react';
import { ILine as Line } from '../../../../global';
import { IProduct as Product } from '../../../../Types';
import Typography from '@material-ui/core/Typography';
import Timeline from './Timeline';

interface Props {
  line: Line;
  newestProduct: Product;
  handleStageUpdate: (...args) => void;
  handleAddStage: (...args) => void;
  addOrDeleteError: (...args) => void;
}

export default function DesktopLine({
  line,
  newestProduct,
  handleStageUpdate,
  handleAddStage,
  addOrDeleteError,
}: Props) {
  return (
    <>
      {newestProduct && (
        <>
          <Timeline
            line={line}
            handleStageUpdate={handleStageUpdate}
            addStage={handleAddStage}
            addOrDeleteError={addOrDeleteError}
          />
          <Typography align="center" paragraph>
            Remove any unnecessary stage, or add a stage.
          </Typography>
        </>
      )}
    </>
  );
}
